export default __webpack_public_path__ + "static/media/Facebook.9e678029.png";